import { useCallback, useMemo } from "react";
import { useInfiniteQuery } from "react-query";
import { ReceivedInvitationType } from "../../types";
import { getReceivedInvitations } from "../api/helpers/apiFunctions/friends";

export const useNotificationsQuery = () => {
  const { isLoading, isFetchingNextPage, hasNextPage, data, refetch, fetchNextPage } = useInfiniteQuery(
    "notifications",
    ({ pageParam = 0 }) => getReceivedInvitations(pageParam),
    {
      getNextPageParam: (lastPage) => (lastPage.nextPage < lastPage.totalPages ? lastPage.nextPage : undefined),
    }
  );

  const refetchQuery = useCallback(() => {
    refetch();
  }, [refetch]);

  const notificationsList = useMemo(
    () => data?.pages.reduce((acc, page) => [...acc, ...page.data], [] as ReceivedInvitationType[]) || [],
    [data]
  );

  return {
    isLoading,
    isFetchingNextPage,
    hasNextPage: !!hasNextPage,
    refetch: refetchQuery,
    fetchNextPage,
    notificationsList,
  };
};
